/**
 * DetailRow Component
 * 
 * Simple key-value row for displaying parcel details.
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { color, space, text } from '../../../shared/tokens/mobile';

interface DetailRowProps {
  label: string;
  value: string;
  highlight?: boolean;
}

export function DetailRow({ label, value, highlight }: DetailRowProps) {
  return (
    <View style={styles.row}>
      <Text style={styles.label}>{label}</Text>
      <Text style={[styles.value, highlight && styles.valueHighlight]}>{value}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: space.xs,
  },
  label: {
    fontSize: text.caption.fontSize,
    color: color.textMuted,
  },
  value: {
    fontSize: text.caption.fontSize,
    color: color.textPrimary,
  },
  valueHighlight: {
    fontWeight: text.bodyMedium.fontWeight,
    color: color.primary,
  },
});

